import { render, staticRenderFns } from "./EditItemModal.vue?vue&type=template&id=ad4affcc&scoped=true"
import script from "./EditItemModal.vue?vue&type=script&lang=js"
export * from "./EditItemModal.vue?vue&type=script&lang=js"
import style0 from "./EditItemModal.vue?vue&type=style&index=0&id=ad4affcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4affcc",
  null
  
)

export default component.exports